// 简体中文
module.exports = {
	common: {
		common_0: "加载中",
		common_1: "提示",
		common_2: "取消",
		common_3: "确定",
	},
	Message: {
		Message_01: "数据保存成功。",
		Message_02: "数据保存失败。",
		Message_03: "没有满足条件的数据。",
		Message_04: "打印的数据超过了1万条，请追加检索条件。",
		Message_05: "这是必须输入的内容。",
        Message_06: "请求失败。",
		Message_07: "请求成功。",
		Message_08: "数据保存失败。",
		Message_09: "数据保存成功。",
		Message_10: "保存成功。 您要继续添加吗？",
		Message_11: "提示",
		Message_12: "您确定要删除吗？",
		Message_13: "提示",
		Message_14: "删除失败",
		Message_15: "删除成功",
		Message_16: "请您在列表中勾选您要删除的用户信息",
	},
	home: {
		home_0: "由于在一定时间内无法确认操作，从安全性的角度考虑退出了。请再次登录。",
		home_1: "错误",
		home_2: "确定",
		home_3: "请求失败"
	},
	login: {
		login_0: "PO+S管理",
		login_1: "会社ID",
		login_2: "登录ID",
		login_3: "密码",
		login_4: "请输入公司ID",
		login_5: "请输入登录ID",
		login_6: "请输入密码",
		login_7: "没有输入数据",
		login_8: "不能登录。请重新看一下输入的内容。",
		login_9: "登录成功",
		login_10: "互联网和无线局域网(wifi)连接不上",		
		login_11: "日本語",
		login_12: "簡体字",
		login_13: "繁体字",
		login_14:"登录",
		login_15:"改变语言失败"
	},
	header: {
		header_0: "PO+S管理平台",
		header_1: "日本語",
		header_2: "简体中文",
		header_3: "繁体中文",
		header_4: "English",
		header_5: "取消全屏",
		header_6: "全屏",
		header_7: "有",
		header_8: "条未读消息",
		header_9: "消息中心",
		header_10: "个人资料",
		header_11: "退出登录"
	},
	tags: {
		tags_0: "标签选项",
		tags_1: "关闭其他",
		tags_2: "关闭所有"
	},
	sidebar: {
		sidebar_0: "系统首页",
		sidebar_1: "菜单管理",
		sidebar_2: "角色管理",
		sidebar_3: "用户管理",
		sidebar_4: "会社管理",
		
		sidebar_5: "商品移动",
		sidebar_6: "商品移动出库处理",
		sidebar_7: "商品移動履歴",
		sidebar_8: "角色管理",
		sidebar_9: "用户管理",
		sidebar_10: "売上金種",
		sidebar_11: "在庫集計（現在庫）",
		sidebar_12: "在庫集計（月末在庫）",
		

	},
	forgetpwd: {
		forgetpwd_0: "找回密码",
		forgetpwd_1: "请输入邮箱",
		forgetpwd_2: "请输入验证码",
		forgetpwd_3: "请输入6-18位新密码",
		forgetpwd_4: "密码长度在6-18位之间",
		forgetpwd_5: "获取验证码",
		forgetpwd_6: "与输入密码不一致",
		forgetpwd_7: "确定",
		forgetpwd_8: "想起来了!",
		forgetpwd_9: "直接登录",
		forgetpwd_10: "验证码不能为空",
		forgetpwd_11: "请输入正确邮箱格式",
		forgetpwd_12: "秒后重新获取",
		forgetpwd_13: "重新获取",
		forgetpwd_14: "验证码错误",
		forgetpwd_15: "登录成功",
		forgetpwd_16: "请输入账号和密码",
		forgetpwd_17: "邮箱不能为空",
		forgetpwd_18: "验证码不正确",
		forgetpwd_19: "修改成功",
		forgetpwd_20: "请先注册该邮箱号",
		forgetpwd_21: "验证码已经超时",
		forgetpwd_22: "修改失败",
		forgetpwd_23: "请重复6-18位新密码",
		forgetpwd_24: "邮箱与验证码不匹配",
		forgetpwd_25: "验证码必须是6位",
		forgetpwd_26: "获取中"
	},
	Analysisinventorycurrent: {
		Analysisinventorycurrent_0: "在库统计（現在库）",
		Analysisinventorycurrent_1: "选项",
		Analysisinventorycurrent_2: "店铺",
		Analysisinventorycurrent_3: "分类",
		Analysisinventorycurrent_4: "大分类",
		Analysisinventorycurrent_5: "中分类",
		Analysisinventorycurrent_6: "小分类",
		Analysisinventorycurrent_7: "制造商",
		Analysisinventorycurrent_8: "JAN",
		Analysisinventorycurrent_9: "品番",
		Analysisinventorycurrent_10: "品名1",
		Analysisinventorycurrent_11: "品名2",
		Analysisinventorycurrent_12: "属性1",
		Analysisinventorycurrent_13: "属性2",
		Analysisinventorycurrent_14: "组1",
		Analysisinventorycurrent_15: "组2",
		Analysisinventorycurrent_16: "最终入库日",
		Analysisinventorycurrent_17: "供应商",
		Analysisinventorycurrent_18: "搜索",
		Analysisinventorycurrent_19: "请求失败",
		Analysisinventorycurrent_20: "暂无数据",
		Analysisinventorycurrent_21: "请选择最终入库日",
		Analysisinventorycurrent_22: "数据超过10000条，请追加检索条件",
		Analysisinventorycurrent_23: "数据超过30000條，请追加检索条件",
		Analysisinventorycurrent_24: "升序",
		Analysisinventorycurrent_25: "降序",
	},
	Analysisinventoryeom: {
		Analysisinventoryeom_0: "在库统计（月末在库）",
		Analysisinventoryeom_1: "选项",
		Analysisinventoryeom_2: "店铺",
		Analysisinventoryeom_3: "分类",
		Analysisinventoryeom_4: "大分类",
		Analysisinventoryeom_5: "中分类",
		Analysisinventoryeom_6: "小分类",
		Analysisinventoryeom_7: "厂家",
		Analysisinventoryeom_8: "JAN",
		Analysisinventoryeom_9: "品番",
		Analysisinventoryeom_10: "品名1",
		Analysisinventoryeom_11: "品名2",
		Analysisinventoryeom_12: "属性1",
		Analysisinventoryeom_13: "属性2",
		Analysisinventoryeom_14: "组1",
		Analysisinventoryeom_15: "组2",
		Analysisinventoryeom_16: "年月",
		Analysisinventoryeom_17: "搜索",
		Analysisinventoryeom_18: "请求失败",
		Analysisinventoryeom_19: "升序",
		Analysisinventoryeom_20: "降序",
		Analysisinventoryeom_21: "请选择年月",
		Analysisinventoryeom_22: "暂无数据",
		Analysisinventoryeom_23: "请选择店铺",
		Analysisinventoryeom_24: "数据超过10000条，请追加检索条件",
		Analysisinventoryeom_25: "数据超过30000條，请追加检索条件",
		
	},
	
	Dashboard: {
		Dashboard_0: "系统首页",
		Dashboard_1: "本周店铺数量",
		Dashboard_2: "本周导游数量",
		Dashboard_3: "本周代理商数量",
		Dashboard_4: "本周订单成交量",
		Dashboard_5: "同比上周",
		Dashboard_6: "消息",
		Dashboard_7: "查看更多",
		Dashboard_8: "订单销售金额统计",
		Dashboard_9: "近7天成交统计",
		Dashboard_10: "近3天",
		Dashboard_11: "近7天",
		Dashboard_12: "近30天",
		Dashboard_13: "日期",
		Dashboard_14: "销售金额",
		Dashboard_15: "近3天成交统计",
		Dashboard_16: "近30天成交统计",
		Dashboard_17: "注册统计",
		Dashboard_18: "导游",
		Dashboard_19: "店铺",
		Dashboard_20: "代理商",
		Dashboard_21: "请求失败",
		Dashboard_22: "店铺类型"
	},

	
	T13011: {
		T13011_0: "伝票ID",
		T13011_1: "担当者",
		T13011_2: "入力日",
		T13011_3: "入荷伝票ID",
		T13011_4: "移動元",
		T13011_5: "備考",
		T13011_6: "移動先",
		T13011_7: "JAN ",
		T13011_8: "数量合計",
		T13011_9: "メーカー",
		T13011_10: "大分類 ",
		T13011_11: "中分類",
		T13011_12: "小分類 ",
		T13011_13: "品番",
		T13011_14: "品名",
		T13011_15: "品名2",
		T13011_16: "属性1 ",
		T13011_17: "属性2",
		T13011_18: "属性3 ",
		T13011_19: "標準価格",
		T13011_20: "数量",
		T13011_21: "金額",
		T13011_22: "備考",
		T13011_23: "金額",
		T13011_24: "数据保存成功。",
		T13011_25: "数据保存失败。",
		T13011_26: "请求失败",
		T13011_27: "商品移动",
		T13011_28: "盘点中，无法进行商品调拨。\n盘点结束后，请再次录入。",
		T13011_29: "无数据",
		T13011_30: "運送業者",
		T13011_31: "送り状番号",
		T13011_32: "输入的 JAN 不存在。", 
		T13011_33: "表单验证失败",
		T13011_34: "リセット",
		T13011_35: "登 録",		
		T13011_36: "即時入庫",
		T13011_37: "删除",
	},
	// message:
	// {
	// 	message_10101: "入力してください。",
	// 	message_10106: "输入的 {0} 不存在。",
	// },
	T13021: {
		T13021_0: "商品移動",		
		T13021_1:"メーカー",
		T13021_2:"移動元",
		T13021_3:"伝票ID",
		T13021_4:"状態",
		T13021_5:"JAN",
		T13021_6:"移動先",
		T13021_7:"キーワード",
		T13021_8:"備考",
		T13021_9:"品番",
		T13021_10:"処理日時",
		T13021_11:"品名",
		T13021_12:"移動伝票ID",
		T13021_13:"移動状態 ",
		T13021_14:"移動元 ",
		T13021_15:"移動先 ",
		T13021_16:"入力者 ",
		T13021_17:"入力日 ",
		T13021_18:"発送者 ",
		T13021_19:"発送日 ",
		T13021_20:"入庫者 ",
		T13021_21: "入庫日 ",
		T13021_22: "送り状ID ",
		T13021_23:"リセット",
		T13021_24:"导出Excel",
		T13021_25:"",
		T13021_26:"搜索",
		T13021_27:"发送",
		T13021_28:"入库",
		T13021_29:"再发行",
		T13021_30:"照会",
		T13021_31:"编辑",
		T13021_32:"删除",
		T13021_33:"品名",
		T13021_34:"削除も表示",
		T13021_35:"自店に関係あるものだけ表示",
		T13021_36: "開始日付",
		T13021_37: "終了日付",
		T13021_38: "请求失败",
		T13021_39: "操作",
		T13021_40: "您确定要操作吗？",
		T13021_41: "提示",
		T13021_42: "操作失败",
		T13021_43: "操作成功",
		T13021_table0: "JAN",
		T13021_table1: "メーカー",		
		T13021_table2: "大分類",
		T13021_table3: "中分類",
		T13021_table4: "小分類",		
		T13021_table5: "品番",
		T13021_table6: "品名",
		T13021_table7: "品名2",		
		T13021_table8: "標準価格",
		T13021_table9: "数量",
		T13021_table10: "金額",		
		T13021_table11: "備考",
		T13021_table12: "删除标志",
		T13021_table13: "社内JAN",
		T13021_44: "此操作将导出excel文件, 是否继续?",
		T13021_45: "确定",
		T13021_46: "取消",
		T13021_47: "移動元店舗",
		T13021_48: "移動先店舗",
		T13021_49: "ブランド",
		T13021_50: "サイズ",
		T13021_51: "カラー",
		T13021_52: "移動リスト",		
		T13021_53: "请选择明细行。",			
		},		
	NavEdit:{
			NavEdit_0:"メニュー管理",
			NavEdit_1:"上级导航",
			NavEdit_2:"排序",
			NavEdit_3:"显示",
			NavEdit_4:"调用别名",
			NavEdit_5:"导航名称(日本)",
			NavEdit_6:"导航名称(中国)",
			NavEdit_7:"导航名称(台湾)",
			NavEdit_8:"副标题",
			NavEdit_9:"链接地址",
			NavEdit_10:"备注说明",
			NavEdit_11:"权限分配",
			NavEdit_12:['显示(Show)','查看(View)','添加(Add)','修改(Edit)','删除(Delete)','审核(Audit)','回复(Reply)','确认(Confirm)','取消(Cancel)','作废(Invalid)','生成(Build)','安装(Instal)','卸载(Unload)','备份(Back)','还原(Restore)','替换(Replace)'],
			NavEdit_13:"*数字，越小越向前",
			NavEdit_14:"隐藏后不显示在界面导航菜单中",
			NavEdit_15:"权限控制名称，只允许字母、数字、下划线，与栏目管理-栏目名称相对应。",
			NavEdit_16:"*导航标题，100字符内",
			NavEdit_17:"非必填，当导航拥有两个名称时使用",
			NavEdit_18:"当前管理目录，有子导航不用填",
			NavEdit_19:"非必填，可为空",	
			NavEdit_20:"必填，不能为空",
			NavEdit_21:"保存",
			NavEdit_22:"返回",
			NavEdit_23:'请求失败',
			NavEdit_24:'保存成功',
			NavEdit_25:'保存失败',
			NavEdit_26:'表单验证失败',
			NavEdit_27:'该权限名称被占用，请更换',
			NavEdit_28:'该权限名称可以使用',
			NavEdit_29:'请选择导航下拉列表',
		},
		NavList:{
			NavList_0:"菜单管理",
			NavList_1:"新增",
			NavList_2:"保存",
			NavList_3:"调用别名",
			NavList_4:"标题",
			NavList_5:"显示",
			NavList_6:"排序",
			NavList_7:"操作",
			NavList_8:"添加子级",
			NavList_9:"修改",
			NavList_10:"删除",
		},
	Role_List: {
			Role_List: "角色管理",
			Role_List_0: "新規",
			Role_List_1: "全选",
			Role_List_2: "删除",		
			Role_List_3: "选择",
			Role_List_4: "角色名称",
			Role_List_5: "类型",
			Role_List_6: "操作",
			Role_List_7: "系统用户",
			Role_List_8: "修改",
			Role_List_9: "角色人员",
			Role_List_10: "Admin",
			Role_List_11: "",
			Role_List_12: "",
			Role_List_13: "",
			Role_List_14: "",
		},	
	Role_Edit:{
		Role_Edit_0:"角色管理",
		Role_Edit_1:"角色类型",
		Role_Edit_2:"角色名(日本)",
		Role_Edit_3:"角色名(中国)",
		Role_Edit_4:"角色名(台湾)",
		Role_Edit_5:"侧菜单",
		Role_Edit_6:"全选",
		Role_Edit_7:"权限",
		Role_Edit_8:"保存",
		Role_Edit_9:"返回",
		Role_Edit_10:"管理者权限",
		Role_Edit_11:"请输入角色名(日本)。",
		Role_Edit_12:"请输入役割名(中国)。",
		Role_Edit_13:"请输入役割名(台湾)。",
		Role_Edit_14:"请选择角色类型。",
		Role_Edit_15:"表单验证失败",
	},
	AnalysisGoldstat: {
		AnalysisGoldstat_0: "升序",
		AnalysisGoldstat_1: "降序"
	},
	Analysissales: {
		Analysissales_0: "升序",
		Analysissales_1: "降序"
	},
	Analysissalesec: {
		Analysissalesec_0: "升序",
		Analysissalesec_1: "降序"
	},
	Analysismove: {
		Analysismove_0: "升序",
		Analysismove_1: "降序"
	},
	Managers: {
		Managers_0: "选择角色名称",
		Managers_1: "职员代码/姓名/邮箱地址",
		Managers_2: "账户名",
		Managers_3: "姓名",
		Managers_4: "电话号",
		Managers_5: "角色名",
		Managers_6: "登陆时间",
		Managers_7: "状态",
		Managers_8: "操作",
		Managers_9: "变更",
		Managers_10: "是否确认此操作?",
		Managers_11: "提示",
		Managers_12: "确定",
		Managers_13: "取消",
		Managers_14: "删除成功",
		Managers_15: "已取消",
		Managers_16: "正常",
		Managers_17: "禁止",
		Managers_18: "请求失败",
		Managers_19: "删除失败",
		Managers_20: "用户管理"	,
		Managers_21: "删除",
		Managers_22:"请选择要删除的信息",
		
		Managers_23: "选择角色名称",
		Managers_24: "请输入内容",
		Managers_25: "保存",
		Managers_26: "返回",
		Managers_27: "保存成功",
		Managers_28: "保存失敗",
		Managers_29: "请求失败",	
		Managers_30: "用户管理",
		Managers_31: "提示",
		Managers_32: "确认提交吗？",
	},
	menusList: {
		menusList_0: "菜单管理",
		menusList_1: "请搜索菜单名称",
		menusList_2: "搜索",
		menusList_3: "新增",
		menusList_4: "拼命加载中",
		menusList_5: "菜单名称",
		menusList_6: "图标",
		menusList_7: "类型",
		menusList_8: "目录",
		menusList_9: "菜单",
		menusList_10: "按钮",
		menusList_11: "上级菜单",
		menusList_12: "菜单URL",
		menusList_13: "授权标识",
		menusList_14: "排序",
		menusList_15: "操作",
		menusList_16: "编辑",
		menusList_17: "删除",
		menusList_18: "新增菜单",
		menusList_19: "编辑菜单",
		menusList_20: "菜单类型：",
		menusList_21: "名称：",
		menusList_22: "顶级菜单",
		menusList_23: "授权标识：",
		menusList_24: "菜单路由：",
		menusList_25: "URL格式：",
		menusList_26: "1.常规业务开发的功能URL，如用户管理，pages目录下页面路径为 /users/usersList, 此处填写 /users/usersList。",
		menusList_27: "2.嵌套外部网页，如通过菜单打开百度网页，此处填写 http://www.baidu.com，http:// 不可省略。",
		menusList_28: "示例：用户管理：/users/usersList 嵌套百度：http://www.baidu.com 嵌套网页：http://127.0.0.1:8000",
		menusList_29: "排序编号：",
		menusList_30: "菜单图标：",
		menusList_31: "菜单图标名称（如：el-icon-s-home）",
		menusList_32: "返回",
		menusList_33: "确认",
		menusList_34: "名称不能为空",
		menusList_35: "请求失败",
		menusList_36: "您确定要删除吗？",
		menusList_37: "提示",
		menusList_38: "删除失败",
		menusList_39: "删除成功",
		menusList_40: "确认提交吗？",
		menusList_41: "菜单名称不能重复新增",
		menusList_42: "操作失败",
		menusList_43: "操作成功",
		menusList_44: "上级菜单："
	},
	rolesList: {
		rolesList_0: "角色管理",
		rolesList_1: "请搜索角色名",
		rolesList_2: "开始日期",
		rolesList_3: "结束日期",
		rolesList_4: "搜索",
		rolesList_5: "新增",
		rolesList_6: "角色名",
		rolesList_7: "备注",
		rolesList_8: "创建人",
		rolesList_9: "创建时间",
		rolesList_10: "操作",
		rolesList_11: "编辑",
		rolesList_12: "删除",
		rolesList_13: "新增角色",
		rolesList_14: "编辑角色",
		rolesList_15: "返回",
		rolesList_16: "提交",
		rolesList_17: "拼命加载中",
		rolesList_18: "全选",
		rolesList_19: "重置",
		rolesList_20: "请输入角色名",
		rolesList_21: "请求失败",
		rolesList_22: "您确定要删除吗？",
		rolesList_23: "提示",
		rolesList_24: "删除失败",
		rolesList_25: "删除成功",
		rolesList_26: "确认提交吗？",
		rolesList_27: "角色名称不能重复新增",
		rolesList_28: "操作失败",
		rolesList_29: "操作成功",
		rolesList_30: "超级管理员拥有所有菜单权限，不允许修改！",
		rolesList_31: "目录",
		rolesList_32: "菜单",
		rolesList_33: "按钮",
		rolesList_34: "顶级菜单",
		rolesList_35: "角色菜单授权",
		rolesList_36: "角色名：",
		rolesList_37: "备注：",
		rolesList_38: "检索",
		rolesList_39: "角色管理",
		rolesList_40: "ID",
		rolesList_41: "删除。可以吗?",
		rolesList_42: "数据删除成功了。",
		rolesList_43: "数据删除失败了。",
		rolesList_44: "数据登录成功。",
		rolesList_45: "数据登录失败。",
		rolesList_46: "输入的角色名称已经存在。\n请再试一次。",
		rolesList_47: "登录数据。可以吗?",
	},
	Category:{
		Category_0:"",
		Category_1:"销售金额",
		Category_2:"去年销售率",
		Category_3:"盈利金额",
		Category_4:"盈利率",
		Category_5:"去年盈利率",
		Category_6:"退还金额",
		Category_7:"退还比率",
		Category_8:"进货金额",
		Category_9:"加价率",
		Category_10:"在库金额",
		Category_11:"搜索",
	}
}	
	
